import Smartphones from 'Todo/views/TodoIntegrationView/containers/Smartphones'
import Tablets from 'Todo/views/TodoIntegrationView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const TodoIntegrationView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoIntegrationView
